import FormBtn from "@/components/ui/form-btn";

const NewsLetterSec = ({newsletterSection, email, handleEmailChange, isValidEmail, handleNewsletterSubscription}) =>{
    return(
        <div className="bg-[#2a2a2a] py-4 lg:py-[2vw]">
        <div className="container lg:px-[4vw]">
          <div className="flex flex-wrap items-center justify-between">
            <div className="w-full md:w-2/6 lg:text-[0.938vw] *:mb-3 *:lg:mb-[.5vw] font-normal mb-5 md:mb-0">
              {newsletterSection && <h4 className="font-secondary text-white text-xl lg:text-[1.7vw]">
                {newsletterSection?.title || ""}
              </h4>}
              {newsletterSection?.desc && <p>{newsletterSection?.desc || ""}</p>}
            </div>
            <div className="w-full md:w-6/12 border-b border-solid border-primary pb-2 lg:pb-[1vw]">
              <div className="flex items-center gap-x-4 lg:gap-x-[1vw]">
                <div className="grow">
                  <input
                    type="email"
                    placeholder={"Enter Email ID"}
                    className={"w-full bg-transparent"}
                    value={email}
                    onChange={handleEmailChange}
                  />
                  {!isValidEmail && (
                    <p className="form-submit-error-message">Invalid email</p>
                  )}
                </div>
                <div>
                  <FormBtn
                    name={"Subscribe"}
                    customClass={
                      "tracking-[1.8px] border border-solid border-white hover:bg-black"
                    }
                    onClick={handleNewsletterSubscription}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default NewsLetterSec;